import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { ApiError, apiRequest } from '../../application/axios';
import { ADMINISTRATOR_API_URL } from '../../enviroments';

export enum ActionType {
    RESET_PASSWORD = 'RESET_PASSWORD',
    ACTIVATION = 'ACTIVATION',
    DEACTIVATION = 'DEACTIVATION',
}

interface PerformBatchAction {
    administratorIds: string[];
    actionType: ActionType;
}

export const performBatchAction = createAsyncThunk<
    void,
    PerformBatchAction,
    {
        rejectValue: ApiError;
    }
>('users/batchPerformAction', async (actionData, { rejectWithValue }) => {
    const response = await apiRequest<void>({
        url: `${ADMINISTRATOR_API_URL}/v1/administrators/batchAction`,
        method: 'post',
        data: actionData,
    });
    if (response instanceof ApiError) {
        return rejectWithValue(response);
    }
    return;
});

interface BatchState {
    loading: boolean;
    error: string[];
    success: boolean;
}

// Initial state
const initialState: BatchState = {
    loading: false,
    error: [],
    success: false,
};

const batchSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(performBatchAction.pending, (state) => {
                state.loading = true;
                state.error = [];
                state.success = false;
            })
            .addCase(performBatchAction.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(performBatchAction.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload?.globalErrors || ['Something went wrong'];
                state.success = false;
            });
    },
});

export default batchSlice.reducer;
